import { LabelWithHelp } from "@components/common/label-with-help";
import { AccessLevelLDescription } from "@components/project/project-access-level-utils";
import { PROJECTS_TABLE_COLUMN_LABELS } from "@components/table/projects/projects-table-constants";
import { AccessLevelDisplayNames } from "@custom-types/project-types";
import { Box } from "@mui/material";
import { neutral } from "@flat-ui";

/** Tooltip for access level component */
export function ProjectAccessLevelTooltip(): JSX.Element {
  return (
    <LabelWithHelp
      title={PROJECTS_TABLE_COLUMN_LABELS.accessLevel}
      help={
        <Box component="div">
          <Box component="div" mb="20px">
            There are two types of access levels:
          </Box>
          <Box component="div" mb="20px">
            {`${AccessLevelDisplayNames.private} - ${AccessLevelLDescription.private}`}
          </Box>
          <Box component="div">
            {`${AccessLevelDisplayNames.unlisted} - ${AccessLevelLDescription.unlisted}`}
          </Box>
        </Box>
      }
      sx={{
        color: neutral[500],
        fontWeight: "normal",
        width: "fit-content",
        fontSize: "11px",
      }}
    />
  );
}
